import { render, staticRenderFns } from "./Messagebox.vue?vue&type=template&id=c13752b8&"
import script from "./Messagebox.vue?vue&type=script&lang=js&"
export * from "./Messagebox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports